define('lib/backbone/Backbone.PodioOverrides',['require','backbone','backbone-super','lib/Podio.Transport'],function(require) {

  var Backbone = require('backbone');
  require('backbone-super');

  var transport = require('lib/Podio.Transport');

  // Map Backbone's ajax-method to ours in the transport-layer
  Backbone.ajax = transport.ajax;

});

